import React from 'react'

// Filter / category chip. Selectable, with optional remove (×).
// Used for active-filter rows, category quick-picks.
//
// Usage:
//   <Chip>Hamısı</Chip>
//   <Chip selected>Mobil oyunlar</Chip>
//   <Chip onRemove={() => clear()}>Endirim</Chip>

const Chip = ({
  selected = false,
  onClick,
  onRemove,
  icon,
  className = '',
  children,
  as: Tag = 'button',
  ...rest
}) => {
  const base = 'inline-flex items-center gap-1.5 px-3 h-8 text-xs font-semibold rounded-pill transition-colors select-none'
  const state = selected
    ? 'bg-brand-600 text-white border border-brand-600 hover:bg-brand-700'
    : 'bg-white text-slate-700 border border-slate-200 hover:border-brand-400 hover:text-brand-700'

  return (
    <Tag
      type={Tag === 'button' ? 'button' : undefined}
      onClick={onClick}
      className={[base, state, className].join(' ')}
      {...rest}
    >
      {icon && <span className='inline-flex shrink-0'>{icon}</span>}
      <span className='truncate max-w-[160px]'>{children}</span>
      {onRemove && (
        <span
          role='button'
          tabIndex={-1}
          aria-label='Sil'
          onClick={(e) => { e.stopPropagation(); onRemove() }}
          className={`ml-1 inline-flex items-center justify-center w-4 h-4 rounded-full leading-none text-[12px] ${selected ? 'bg-white/20 text-white hover:bg-white/30' : 'bg-slate-100 text-slate-500 hover:bg-slate-200'}`}
        >
          ×
        </span>
      )}
    </Tag>
  )
}

export default Chip
